var lastScroll = 0;
window.addEventListener('scroll',(e) => {
  let scrollCount = window.pageYOffset;
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 0);
  let header = document.querySelector('.main-header');
  if(document.querySelector('.template-index')){
    if(scrollCount > 0){
      header.classList.add('sticky_header');
    }else{
      header.classList.remove('sticky_header');
    }
  }else{
    if(scrollCount > header.offsetTop){
      header.classList.add('sticky_header');
    }
    if(scrollCount < document.querySelector('.main-announcement-bar').clientHeight && document.body.classList.contains('scroll-up')) header.classList.remove('sticky_header');
  }
})
document.addEventListener("DOMContentLoaded", (event) => {
  let header = document.querySelector('.main-header');
  if(document.querySelector('.template-index')){
    if(window.pageYOffset > 0){
      header.classList.add('sticky_header');
    }else{
      header.classList.remove('sticky_header');
    }
  }else{
    if(window.pageYOffset > header.offsetTop){
      header.classList.add('sticky_header');
    }
    if(window.pageYOffset < document.querySelector('.main-announcement-bar').clientHeight && document.body.classList.contains('scroll-up')) header.classList.remove('sticky_header');
  }
});
let mb_drawer = document.querySelector('.menu-drawer-inr');
if(mb_drawer) mb_drawer.addEventListener('scroll',(e) => {
  if(window.innerWidth < 992){
    let searchTop = mb_drawer.scrollTop;
    let getTop = document.querySelector('.search-wrapper').offsetTop;
    if(searchTop > getTop){
      document.querySelector('.menu-drawer-inr').classList.add('active-mb-head');
    }else{
      document.querySelector('.menu-drawer-inr').classList.remove('active-mb-head');
    }
  }
});
document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector('.menu-burdger').addEventListener('click',function(e){
    e.preventDefault();
    if(__st.p == 'home' && window.innerWidth <= 991){
      if (intentObserver && preventScroll) {
        intentObserver.disable();
        preventScroll.disable();
      }
    }
    document.body.classList.add('open-menu');
    document.body.classList.remove('open-drawer','open-search','open-sort','open-filter','active-popup','open-currency','filter-sticky');
  });
  document.querySelector('.mobile-search').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector(".md-search #Search").focus();
    document.body.classList.add('open-search','open-menu');
    document.body.classList.remove('open-drawer','open-sort','open-filter','active-popup','open-currency');
  });
  document.querySelectorAll('.close-menu,.menu-drawer-overly').forEach(function(menuClose){
    menuClose.addEventListener('click',function(e){
      e.preventDefault();
      if(__st.p == 'home' && window.innerWidth <= 991){
        if (intentObserver && preventScroll) {
          intentObserver.enable();
          preventScroll.enable();
        }
      }
      if(document.body.classList.contains('open-second-level')){
        document.body.classList.remove('open-second-level');
        if(window.innerWidth <= 991){
          document.body.classList.remove('close-main-level');
        }
        setTimeout(() => {
          document.body.classList.remove('open-menu','open-search');
        }, 500);
      }else{
        document.body.classList.remove('open-menu','open-search');
      }
    });
  });
  document.querySelectorAll('.md-mega-back,.lang-curr-head').forEach(function(menuBack){
    menuBack.addEventListener('click',function(e){
      e.preventDefault();
      if(document.querySelector('.menu-drawer-inr')){
        document.querySelector('.menu-drawer-inr').classList.remove('active-mb-head');
      }
      document.body.classList.remove('open-second-level','open-search');
      if(window.innerWidth <= 991){
        setTimeout(() => {
          document.body.classList.remove('close-main-level');
        }, 500);
      }
    });
  });
  document.querySelectorAll('.megamenu a').forEach(function(megamenu){
    megamenu.addEventListener('click',function(e){
      e.preventDefault();
      let title = megamenu.getAttribute('data-name');
      document.querySelectorAll('.menu-drawer-sub-level .md-lang-curr-inr').forEach((lang) => {
        lang.classList.remove('active-child');
      })
      document.querySelectorAll('.menu-drawer-sub-level .child-nav').forEach((nav) => {
        let all_title = nav.getAttribute('data-name');
        if(all_title == title){
          nav.classList.add('active-child');
        }else{
          nav.classList.remove('active-child');
        }
      })
      document.querySelectorAll('.md-lang-curr a').forEach(function(lang_curr_rm){
        lang_curr_rm.closest('li').classList.remove('active-menu');
      });
      document.querySelectorAll('.megamenu a').forEach(function(megamenuRemove){
        megamenuRemove.closest('li').classList.remove('active-menu');
      });
      megamenu.closest('li').classList.add('active-menu');
      if(window.innerWidth <= 991){
        document.body.classList.add('close-main-level');
        setTimeout(() => {
          document.body.classList.add('open-second-level');
        }, 500);
      }else{
        document.body.classList.add('open-second-level');
      }
    });
  });
  document.querySelectorAll('.md-lang-curr a').forEach(function(lang_curr){
    lang_curr.addEventListener('click',function(e){
      e.preventDefault();
      let title = lang_curr.getAttribute('data-name');
      document.querySelectorAll('.menu-drawer-sub-level .child-nav').forEach((nav) => {
        nav.classList.remove('active-child');
      })
      document.querySelectorAll('.menu-drawer-sub-level .md-lang-curr-inr').forEach((lang) => {
        let all_title = lang.getAttribute('data-name');
        if(all_title == title){
          lang.classList.add('active-child');
        }else{
          lang.classList.remove('active-child');
        }
      })
      document.querySelectorAll('.megamenu a').forEach(function(megamenuRemove){
        megamenuRemove.closest('li').classList.remove('active-menu');
      });
      document.querySelectorAll('.md-lang-curr a').forEach(function(lang_curr_rm){
        lang_curr_rm.closest('li').classList.remove('active-menu');
      });
      lang_curr.closest('li').classList.add('active-menu');
      if(window.innerWidth <= 991){
        document.body.classList.add('close-main-level');
        setTimeout(() => {
          document.body.classList.add('open-second-level');
        }, 500);
      }else{
        document.body.classList.add('open-second-level');
      }
      if(document.querySelectorAll('.md-lang-curr-inr[data-name="language"] .disclosure__list .disclosure__item .weglot-link')) document.querySelectorAll('.md-lang-curr-inr[data-name="language"] .disclosure__list .disclosure__item .weglot-link').forEach((language) => {
        language.addEventListener('click',function(e){
          e.preventDefault();
          localStorage.setItem("Language",language.getAttribute('data-val'));
        });
      });
    });
  });
  document.addEventListener('click', function(e){
    let subLevel = document.querySelectorAll('.menu-drawer-sub-level,.md-nav a');
    let isInsideClick = false;
    subLevel.forEach(function(element){
      if (element.contains(e.target) || element === e.target) isInsideClick = true;
    });
    if(!isInsideClick){
      document.body.classList.remove('open-second-level');
    }
  });
});